module.exports = __webpack_public_path__ + "img/home-img-04.08ce6eb1.png";